import QAndAProvider from './QAndA.provider';

export default QAndAProvider;
